import { FC } from "react";
import {
  createStyles,
  Grid,
  makeStyles,
  useMediaQuery,
} from "@material-ui/core";

import { ListingGridItem } from "components";
import { InventoryListing } from "services/inventory/types";
import theme from "theme";

const useStyles = makeStyles(() =>
  createStyles({
    listingsGridContainer: {
      "&::after": {
        content: "''",
        flex: "auto",
      },
    },
  }),
);

export interface ListingsGridProps {
  listings: InventoryListing[];
  prevUrl: string;
  hideUserNotificationTags?: string[];
  userId: number;
  refetchOnModalClose?: boolean;
}

const ListingsGrid: FC<ListingsGridProps> = ({
  listings,
  prevUrl,
  hideUserNotificationTags,
  refetchOnModalClose = true,
}) => {
  const classes = useStyles();
  const isDownMd = useMediaQuery(theme.breakpoints.down("md"), { noSsr: true });

  return (
    <Grid
      container
      spacing={2}
      justify={isDownMd || listings.length < 3 ? "center" : "space-between"}
      className={listings.length > 3 ? classes.listingsGridContainer : ""}
    >
      {listings.map(listing => (
        <ListingGridItem
          key={`${listing.listing_id}-${listing.kind}`}
          listing={listing}
          prevUrl={prevUrl}
          hideUserNotificationTags={hideUserNotificationTags}
          refetchOnModalClose={refetchOnModalClose}
        />
      ))}
    </Grid>
  );
};

export default ListingsGrid;
